import { kartaPrzedmiotuActionTypes } from '.';
import { UpdateFormDataPayload } from './interfaces';
type tabId = DynamicTabComponent['id'];

export const init = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.INIT,
    payload: { tabId },
  } as const);
export const getLeftPanelData = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.GET_LEFT_PANEL_DATA_START,
    payload: { tabId },
  } as const);
export const fetchCardData = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FETCH_CARD_DATA_START,
    payload: { tabId },
  } as const);
export const fetchCardDataFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FETCH_CARD_DATA_FAIL,
    payload: { tabId },
  } as const);
export const setFormTemplateVersion = (tabId: tabId, wersjaSzablonuKarty: string) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_TEMPLATE_SET_VERSION,
    payload: { tabId, wersjaSzablonuKarty },
  } as const);
export const updateEditModeStatus = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_UPDATE_EDIT_MODE_STATUS,
    payload: { tabId },
  } as const);
export const toggleEditMode = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_TOGGLE_EDIT_MODE,
    payload: { tabId },
  } as const);
export const getFormTemplate = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_START,
    payload: { tabId },
  } as const);
export const getFormTemplateSuccess = (tabId: tabId, data: any) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_SUCCESS,
    payload: { tabId, data },
  } as const);
export const getFormTemplateFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_TEMPLATE_GET_FAIL,
    payload: { tabId },
  } as const);
export const getFormData = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_GET_START,
    payload: { tabId },
  } as const);
export const getFormDataSuccess = (tabId: tabId, data: any) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_GET_SUCCESS,
    payload: { tabId, data },
  } as const);
export const getFormDataFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_GET_FAIL,
    payload: { tabId },
  } as const);
// verify: skad ten readONly, da sie inaczej?
export const saveFormData = (tabId: tabId, readOnly: boolean) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_START,
    payload: { tabId, readOnly },
  } as const);
// verify: readOnly jako optional, nie podoba mi sie to
export const saveFormDataSuccess = (tabId: tabId, readOnly?: boolean) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_SUCCESS,
    payload: { tabId, readOnly },
  } as const);
export const saveFormDataFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_SAVE_FAIL,
    payload: { tabId },
  } as const);
export const updateFormData = (tabId: tabId, { dataIndex, data, formKey }: UpdateFormDataPayload) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_DATA_UPDATE,
    payload: { tabId, dataIndex, data, formKey },
  } as const);
export const resetFormData = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.FORM_RESET_DATA,
    payload: { tabId },
  } as const);
export const saveTemporarilyInSID = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.KARTA_SAVE_TEMPORARILY_IN_SID_START,
    payload: { tabId },
  } as const);
export const saveTemporarilyInSIDFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.KARTA_SAVE_TEMPORARILY_IN_SID_FAIL,
    payload: { tabId },
  } as const);
/* Akcja inicjuje zapis w SID karty przedmiotów oraz efektów kierunkowych, wywoływana z poziomu interfejsu użytkownika */
export const initPublishing = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.INIT_PUBLISHING,
    payload: { tabId },
  } as const);
/* Akcja publikacji karty przedmiotów w SID, wywoływana z poziomu sagi */
export const publishCardInSID = (tabId: tabId, wersjaSzablonuKarty: string, przedmiotId: Przedmiot['przedmiotId']) =>
  ({
    type: kartaPrzedmiotuActionTypes.KARTA_PUBLISH_IN_SID_START,
    payload: { tabId, wersjaSzablonuKarty, przedmiotId },
  } as const);
/* Akcja publikacji efektów kierunkowych w SID, wywoływana z poziomu sagi */
export const publishLearningEffectsInSID = (tabId: tabId, wersjaSzablonuKarty: string, przedmiotId: Przedmiot['przedmiotId']) =>
  ({
    type: kartaPrzedmiotuActionTypes.LEARNING_EFFECTS_PUBLISH_IN_SID_START,
    payload: { tabId, wersjaSzablonuKarty, przedmiotId },
  } as const);
export const getCardFromSid = (tabId: tabId, readOnly: boolean) =>
  ({
    type: kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_START,
    payload: { tabId, readOnly },
  } as const);
export const getCardFromSidSuccess = (tabId: tabId, readOnly?: boolean) =>
  ({
    type: kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_SUCCESS,
    payload: { tabId, readOnly },
  } as const);
export const getCardFromSidFail = (tabId: tabId) =>
  ({
    type: kartaPrzedmiotuActionTypes.GET_CARD_FROM_SID_FAIL,
    payload: { tabId },
  } as const);
// const kartaPrzedmiotuActions = {
//   subjectCardInit: (payload: AttrTypesOfDynamicTab): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_INIT,
//     payload,
//   }),
//   getFormTemplateStart: (payload: GetFormTemplateStart['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_GET_FORM_TEMPLATE_START,
//     payload,
//   }),
//   getFormDataStart: (payload: GetFormDataStart['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_GET_FORM_DATA_START,
//     payload,
//   }),
//   saveFormDataStart: (payload: SaveFormDataStart['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_SAVE_FORM_DATA_START,
//     payload,
//   }),
//   updateFormData: (id: string, payload: UpdateFormData['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_UPDATE_FORM_DATA,
//     payload: { ...payload, id },
//   }),
//   resetFormData: (payload: ResetFormData['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_RESET_FORM_DATA,
//     payload,
//   }),
//   setTemplateVersionForm: (payload: SetTemplateVersionForm['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_SET_FORM_TEMPLATE_VERSION,
//     payload,
//   }),
//   toggleReadOnly: (payload: ToggleReadOnly['payload']): KartaPrzedmiotuActionTypes => ({
//     type: TOGGLE_READ_ONLY,
//     payload,
//   }),
//   runEditMode: (payload: SaveFormDataStart['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_RUN_EDIT_MODE,
//     payload,
//   }),
//   saveInSID: (payload: SaveInSID['payload']): KartaPrzedmiotuActionTypes => ({
//     type: KARTA_PRZEDMIOTU_SAVE_IN_SID_START,
//     payload,
//   }),
// };

// export default kartaPrzedmiotuActions;
